import { render, staticRenderFns } from "./infoBranchIntroduction.vue?vue&type=template&id=0ef5856a&scoped=true"
import script from "./infoBranchIntroduction.vue?vue&type=script&lang=js"
export * from "./infoBranchIntroduction.vue?vue&type=script&lang=js"
import style0 from "./infoBranchIntroduction.vue?vue&type=style&index=0&id=0ef5856a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5856a",
  null
  
)

export default component.exports